import { call, put, select, takeLatest } from 'redux-saga/effects'
import { VitalsConstants } from '../store/vitals.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPcrIdSelector } from '../../home/selectors/getPcrId.selector'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { IPcr } from '../../pcr/store/pcr.types'
import { setCustomVitalLabel1, setCustomVitalLabel2, setCustomVitalLabelExists } from '../store/vitals.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* setPreviousVitalCustomLabels() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const vitalItems = pcrDoc.patient?.patientVitals

      if (vitalItems && vitalItems.length !== 0) {
        const lastVital = vitalItems[vitalItems.length - 1]
        const { customVitalLabel1, customVitalLabel2 } = lastVital

        if (customVitalLabel1) yield put(setCustomVitalLabel1(customVitalLabel1))
        if (customVitalLabel2) yield put(setCustomVitalLabel2(customVitalLabel2))
        if (customVitalLabel1 || customVitalLabel2) {
          yield put(setCustomVitalLabelExists(true))
        }
      }
    } catch (e) {
      yield put(throwPcrException(`setPreviousVitalCustomLabels() error: ${e}`))
    }
  }
}

export function* setPreviousVitalCustomLabelsSaga() {
  yield takeLatest([VitalsConstants.SET_ADD_VITAL], performWithMutexHOG, setPreviousVitalCustomLabels)
}
